import { render, staticRenderFns } from "./BoCardImg.vue?vue&type=template&id=592c9a75&scoped=true"
import script from "./BoCardImg.vue?vue&type=script&lang=js"
export * from "./BoCardImg.vue?vue&type=script&lang=js"
import style0 from "./BoCardImg.vue?vue&type=style&index=0&id=592c9a75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592c9a75",
  null
  
)

export default component.exports